<template>
	<div class="home-content">
		<div class="head-select">
			<el-input v-model="searchval" placeholder="请输入机器编号" class="search-input"
				v-if="activeName != 'fifth' && activeName != 'sixth' && activeName != 'seventh'"></el-input>
			<div v-else-if="activeName == 'fifth'">
				预警时长：<el-input v-model="limitday" placeholder="请输入预警限制时长" class="search-input"></el-input>
			</div>
			<el-date-picker style="width:250px;"
				v-if="activeName != 'first' && activeName != 'fifth' && activeName != 'sixth' && activeName != 'seventh'"
				v-model="searchtype" type="daterange" range-separator="至" start-placeholder="开始日期"
				end-placeholder="结束日期" placeholder="选择日期">
			</el-date-picker>
			<el-select v-model="approve" placeholder="请选择"
				v-if="activeName == 'second' && activeName != 'sixth' && activeName != 'seventh'" class="approve-select">
				<el-option v-for="item in approveList" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-button type="primary" class="search-button" @click="search"
				v-if="activeName != 'fifth' && activeName != 'sixth' && activeName != 'seventh'">
				<img src="@/assets/icon/search.png" alt="" class="button-icon">
				查询
			</el-button>
			<el-button type="primary" class="search-button" @click="changeOptions" v-if="activeName == 'fifth'">
				修改预警
			</el-button>
			<el-button type="primary" class="search-button" @click="addpart" v-if="activeName == 'sixth'">
				新增标签
			</el-button>
			<el-button type="primary" class="search-button" @click="addstyle" v-if="activeName == 'seventh'">
				新增款号
			</el-button>
			<el-button type="primary" class="search-button" @click="output" v-if="searchtype2">
				导出excel
			</el-button>
			<el-button type="primary" class="search-button" @click="todp" v-if="activeName == 'fifth'">
				前往大屏
			</el-button>
			<div class="num-total">机针总数：{{ numtotal }}</div>
		</div>
		<div class="change-content">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="针盒数量配置" name="first">
					<num :searchval="searchval2" v-if="activeName == 'first'"></num>
				</el-tab-pane>
				<el-tab-pane label="换针数据明细" name="second">
					<detail :searchval="searchval2" :searchtype="searchtype2" :approve="newapprove" @zentotal="zentotal"
						v-if="activeName == 'second'"></detail>
				</el-tab-pane>
				<el-tab-pane label="换针预警" name="third">
					<warn :searchval="searchval2" :searchtype="searchtype2" v-if="activeName == 'third'"></warn>
				</el-tab-pane>
				<el-tab-pane label="废针管理" name="fourth">
					<scrap :searchval="searchval2" v-if="activeName == 'fourth'"></scrap>
				</el-tab-pane>
				<el-tab-pane label="换针人预警" name="fifth">
					<human :searchval="searchval2" v-if="activeName == 'fifth'" ref="human"></human>
				</el-tab-pane>
				<el-tab-pane label="标签管理" name="sixth">
					<part v-if="activeName == 'sixth'" ref="part"></part>
				</el-tab-pane>
				<el-tab-pane label="款号管理" name="seventh">
					<vstyle v-if="activeName == 'seventh'" ref="vstyle"></vstyle>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import num from '@/components/changedata/boxnum.vue'
import detail from '@/components/changedata/changedetail.vue'
import warn from '@/components/changedata/changewarn.vue'
import scrap from '@/components/changedata/scrap.vue'
import human from '@/components/changedata/human.vue'
import part from '@/components/changedata/part.vue'
import vstyle from '@/components/changedata/type.vue'
import { needleBoxConfig, getwaste, getpeoZenOption, changeZenOption, changeNeedleHistory } from '@/api/index'
import moment from 'moment';

export default {
	components: {
		num, detail, warn, scrap, human, part, vstyle
	},
	data() {
		return {
			activeName: 'second',
			timer1: '',
			timer2: '',
			searchval: '',
			searchval2: '',
			searchtype: [],
			newtimer: [],
			searchtype2: "",
			numtotal: 0,
			approve: 99,
			approveList: [
				{ label: '全部', value: 99 },
				{ label: '成功换针', value: 0 },
				{ label: '强制换针', value: 1 },
			],
			newapprove: 99,
			limitday: 3,
			vtotal: 0
		}
	},
	computed: {
	},
	async created() {
	},
	mounted() {
		this.getNum()
		this.getZenOption()
	},
	watch: {
	},
	methods: {
		search() {
			this.searchval2 = this.searchval;
			this.newapprove = this.approve
			if (!this.searchtype) {
				this.searchtype2 = "";
				return;
			}
			if (this.searchtype.length > 0) {
				var date1 = new Date(this.searchtype[0]);
				date1 = date1.toLocaleDateString();
				date1 = date1 + " 00:00:00";
				var date2 = new Date(this.searchtype[1]);
				date2 = date2.toLocaleDateString();
				date2 = date2 + " 23:59:59";
				this.searchtype2 = date1 + "," + date2;
				this.newtimer = this.searchtype
			} else {
				this.searchtype2 = "";
				this.newtimer = []
			}
		},
		handleClick(active) {
			this.searchval = "";
			this.searchval2 = "";
			this.searchtype = [];
			this.searchtype2 = "";
		},
		getNum() {
			this.numtotal = 0
			let num = 0
			const params = {
				limit: 8,
				page: 1,
			}
			needleBoxConfig(params).then(res => {
				num += res.data.total_stock
				changeNeedleHistory(params).then(res => {
					num += res.data.needle_total
					this.numtotal = num
				})
			})
		},
		output() {
			let token = sessionStorage.getItem("token")
			let bgeindate = moment(this.newtimer[0]).format('yyyy-MM-DD')
			let enddate = moment(this.newtimer[1]).format('yyyy-MM-DD')
			let num = (this.vtotal / 1500).toFixed(0)
			const params = {
				machine_sn: this.searchval2,
				is_approve: this.newapprove == 99 ? '' : this.newapprove,
				beginDate: bgeindate,
				endDate: enddate,
				batoken: token,
				widths: '100,150,150,100,100,150,100,100,100,300,100,100,100'
			}
			let logs = ''
			Object.keys(params).forEach((item, i) => {
				if (params[item]) {
					logs += (i > 0 ? '&' : '?') + item + '=' + params[item]
				}
			})
			console.log('___sett', num)
			this.startDownload(1, +num + 1, logs)
			// for (let i = 0; i < num + 1; i++) {
			// 	setTimeout(() => {
			// 		let url = `https://fmadmin.sewme.cn/index.php/admin/Change/exportExcel?limit=1500&page=${i + 1}` + logs
			// 		window.open(url, '_blank')
			// 	}, 3000 * i);
			// }
		},
		startDownload(current, totalpage, logs) {
			if (current <= totalpage) {
				// 构建当前页的下载链接
				const url = `https://fmadmin.sewme.cn/index.php/admin/Change/exportExcel?limit=1500&page=${current}` + logs

				// 打开链接进行下载
				window.open(url, '_blank');

				// 计算剩余页数
				const remaining = totalpage - current;

				// 如果还有剩余页面，显示提示
				if (remaining > 0) {
					let newcur = current + 1
					// 使用setTimeout避免弹窗被浏览器拦截
					setTimeout(() => {
						if (confirm(`已完成第${newcur - 1}页下载，还剩${remaining}页。点击确定继续下载第${newcur}页？`)) {
							this.startDownload(newcur, totalpage, logs);
						} else {
							alert(`已暂停下载。已完成${newcur - 1}/${totalpage}页，剩余${remaining}页。`);
						}
					}, 500);
				} else {
					alert(`所有${totalpage}页已下载完成！`);
				}
			}
		},
		todp() {
			let token = localStorage.getItem("token")
			let url = 'https://fmadmin.sewme.cn/fmdp/#/human/?token=' + token
			window.open(url)
		},
		getZenOption() {
			getpeoZenOption().then(res => {
				if (res.code == 1) {
					this.limitday = res.data.days
				}
			})
		},
		changeOptions() {
			let data = {
				days: this.limitday
			}
			console.log('___grefs', this.$refs.human)
			let dom = this.$refs.human
			changeZenOption(data).then(res => {
				if (res.code == 1) {
					this.$message.success('修改成功')
					dom.getData()
				}
			})
		},
		addpart() {
			let dom = this.$refs.part
			dom.addparts()
		},
		addstyle() {
			let dom = this.$refs.vstyle
			dom.addStyles()
		},
		zentotal(num) {
			this.vtotal = num
		}
	},
	beforeDestroy() {
	},
}
</script>

<style scoped lang="scss">
.home-content {
	height: calc(100% - 64px);

	.head-select {
		padding: 24px 0 24px 42px;
		display: flex;
		align-items: center;

		.el-date-editor {
			margin-left: 16px;
			width: 185px;
		}
	}

	.search-input {
		width: 245px;
	}

	.search-select {
		width: 185px;
		margin-left: 16px;
	}

	.search-button {
		margin-left: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 14px;
		color: #FEFEFF;
		line-height: 14px;
		padding: 10px 20px;

		.button-icon {
			margin-right: 10px;
			width: 15.5px;
			height: 15.5px;
		}
	}

	.change-content {
		padding: 0 28px;
		height: calc(100% - 88px);
		background: #fff;

		.el-tabs {
			margin-top: 16px;
		}
	}
}

.num-total {
	color: #4f77f3;
	font-size: 18px;
	margin-left: 24px;
}
</style>
<style lang="scss">
.list-con {
	.el-table__header-wrapper {
		th {
			background: #FAFAFA;
			color: #0C0C0C;
		}
	}

	.menu-text {
		cursor: pointer;
		color: #507af9;

		&.default {
			cursor: no-drop;
			color: gray;
		}
	}
}

.out-content {
	text-align: center;
	font-size: 18px;

	.out-input {
		margin-top: 24px;
	}
}

.approve-select {
	margin-left: 16px;
	width: 120px;
}
</style>